import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Grid, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/grid'
import { Swiper, SwiperSlide } from 'swiper/react'

interface IFSlideWrapperProps {
  children: ReactNode[]
  className?: string
}

const SlideWrapper: FC<IFSlideWrapperProps> = ({ children, className }) => {
  const pagination = {
    clickable: true,
    renderBullet: (_, className) => {
      return `<span class=${className}></span>`
    },
  }

  const slides = [...children]
  while (slides.length % 6 !== 0) {
    slides.push(<div key={`empty-${slides.length}`} />)
  }

  return (
    <StyledWrapper className={className}>
      <Swiper
        slidesPerView={2}
        slidesPerGroup={2}
        spaceBetween={10}
        grid={{
          rows: 3,
          fill: 'row',
        }}
        pagination={pagination}
        modules={[Grid, Pagination]}
        className="swiper-container"
      >
        {slides.map((childComponent, index) => (
          <SwiperSlide key={index} className="swiper-item">
            {childComponent}
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledWrapper>
  )
}

export default SlideWrapper

const StyledWrapper = styled.div`
  position: relative;
  padding-bottom: 50px;
  max-width: 100%;
  overflow: hidden;

  .swiper-container {
    overflow: visible;
  }

  .swiper-pagination-bullet,
  .swiper-pagination-bullet-active {
    width: 10px;
    height: 10px;
    background-color: black;
    opacity: 0.25;
  }

  .swiper-pagination-bullet-active {
    opacity: 0.75;
  }

  .swiper-item {
    height: fit-content;
  }

  .swiper-pagination {
    position: absolute;
    bottom: -30px;
  }
`
